module.exports = __webpack_public_path__ + "img/success.4e0a88e3.png";